import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { API_BASE_URL } from "src/swagger/api.client.generated";

/**
 * Nova Insight's on/off + notification-time setting (FLIP-172), backed by the new
 * NotificationSettings table rather than UserSettings - Score/BSB's equivalent settings live on
 * the swagger-generated UserSettingDto/SettingsLocalService, but that DTO/client is generated
 * from a live API instance (`npm run nswag`), which isn't practical to regenerate against here.
 * Calls the two new SettingsController actions directly instead, following the same
 * direct-HttpClient + API_BASE_URL pattern CommunityWarmupService already uses for an endpoint
 * outside the generated client.
 *
 * notificationTime on both the get and save shape is always the raw UTC time as "HH:mm:ss" - the
 * same convention BrainScienceBiteStartTime/MarginOfSafetyStartTime use - so local/UTC conversion
 * stays in settings.component.ts, reusing the moment.js conversion already written there for
 * BSB/Score instead of duplicating it here.
 */
export interface NovaInsightSettingsDto {
  isEnabled: boolean;
  isPushEnabled: boolean;
  notificationTime: string;
}

@Injectable({ providedIn: "root" })
export class NovaInsightSettingsService {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private apiBaseUrl: string
  ) {}

  get(): Observable<NovaInsightSettingsDto> {
    return this.http.get<NovaInsightSettingsDto>(
      `${this.apiBaseUrl}/api/Settings/GetNovaInsightSettings`
    );
  }

  /** isPushEnabled is ignored server-side unless isEnabled is also true - same "no push without in-app" rule Score/BSB enforce. */
  save(isEnabled: boolean, isPushEnabled: boolean, notificationTime: string): Observable<NovaInsightSettingsDto> {
    return this.http.post<NovaInsightSettingsDto>(
      `${this.apiBaseUrl}/api/Settings/SaveNovaInsightSettings`,
      { isEnabled, isPushEnabled, notificationTime }
    );
  }
}
